import gql from 'graphql-tag'

import { Mutation } from '../types-graphql'

export type TDataDownloadAllCoursesMonitoring = Pick<
  Mutation,
  'downloadAllCoursesMonitoring'
>
export const DOWNLOAD_ALL_COURSES_MONITORING = gql`
  mutation ($input: DownloadAllCoursesMonitoringInput!) {
    downloadAllCoursesMonitoring(input: $input) {
      url
      hasNextPage
    }
  }
`
